const Twiter = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="5112"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M76.025514 779.810987c14.111639 1.657832 28.411807 2.532359 42.618318 2.53236 83.783145 0.094872 160.847389-28.022587 221.953633-75.216668-78.134597-1.752704-144.204606-53.127245-166.877858-123.773015 26.659103 5.354201 54.392208 4.474808 80.666957-2.528711-81.736094-16.832527-143.429816-89.032743-143.429817-175.052683v-2.238013c24.520828 13.816076 52.353671 21.798724 80.960088 23.062472C144.044053 394.387599 112.514842 339.606172 112.514842 278.010971c-0.094872-31.039038 8.172393-61.688857 24.231346-88.937871 88.15335 108.498583 219.905365 180.504189 368.395035 189.455021a174.890914 174.890914 0 0 1-4.670634-40.185696c0-97.210001 79.982173-174.85929 178.650531-173.29998a182.928297 182.928297 0 0 1 130.387315 57.313787c40.090824-7.202993 78.528682-20.924197 113.458698-40.67587-12.841811 39.701605-40.869263 73.563701-78.622337 95.457297 35.515063-3.601497 70.155598-12.457456 102.654209-26.175011-23.741173 34.445925-53.902035 64.706525-89.127616 89.228569 0.389219 7.492475 0.484092 15.079823 0.484092 22.572298 0 230.809593-179.819406 497.134248-508.512836 496.939639-100.71176 0-194.709485-29.387288-273.817131-79.892167z m0 0"
      fill={color}
      p-id="5113"
    ></path>
  </svg>
);

export default Twiter;
